import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { ShieldAlert, Upload, X, CheckCircle2 } from 'lucide-react';
import { Input } from '../components/Input';
import { Button } from '../components/Button';
import { supabase } from '../supabase';
export function Pelaporan() {
  const [content, setContent] = useState('');
  const [file, setFile] = useState<File | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const selectedFile = e.target.files[0];
      if (selectedFile.size > 5 * 1024 * 1024) {
        alert('Ukuran file maksimal 5MB');
        return;
      }
      if (!selectedFile.type.startsWith('image/')) {
        alert('Hanya file gambar yang diperbolehkan');
        return;
      }
      setFile(selectedFile);
    }
  };
  const removeFile = () => {
    setFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  // 🔥 FIX DISINI (CONNECT SUPABASE)
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!content.trim()) return;
    setIsSubmitting(true);
    let imageUrl = null;
    try {
      // ✅ upload gambar (optional)
      if (file) {
        const fileName = `public/${Date.now()}-${file.name}`;
        const {
          error: uploadError
        } = await supabase.storage.from('reports').upload(fileName, file);
        if (uploadError) throw uploadError;
        const {
          data
        } = supabase.storage.from('reports').getPublicUrl(fileName);
        imageUrl = data.publicUrl;
      }

      // ✅ insert ke table
      const {
        error: insertError
      } = await supabase.from('reports').insert([{
        content: content,
        image_url: imageUrl
      }]);
      if (insertError) throw insertError;

      // ✅ sukses (UI tetap sama)
      setIsSuccess(true);
      setContent('');
      setFile(null);
    } catch (err: any) {
      console.error(err);
      alert('Gagal kirim: ' + err.message);
    }
    setIsSubmitting(false);
  };
  if (isSuccess) {
    return <div className="min-h-screen bg-pastel-grey-light/30 py-12 flex items-center justify-center" data-id="element-449">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} className="bg-white rounded-3xl p-8 md:p-12 border border-pastel-grey shadow-apple text-center max-w-lg mx-4" data-id="element-450">
          <div className="w-20 h-20 mx-auto bg-green-100 rounded-full flex items-center justify-center mb-6" data-id="element-451">
            <CheckCircle2 className="w-10 h-10 text-green-600" data-id="element-452" />
          </div>
          <h2 className="text-2xl font-bold text-dark mb-4" data-id="element-453">
            Laporan Berhasil Dikirim
          </h2>
          <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-454">
            Terima kasih atas keberanianmu melapor. Laporanmu telah kami terima
            secara anonim dan akan segera ditindaklanjuti oleh pihak sekolah.
          </p>
          <Button onClick={() => setIsSuccess(false)} fullWidth data-id="element-455">
            Buat Laporan Baru
          </Button>
        </motion.div>
      </div>;
  }
  return <div className="min-h-screen bg-pastel-grey-light/30 py-12 flex items-center justify-center" data-id="element-456">
      <div className="max-w-2xl w-full mx-4" data-id="element-457">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="bg-white rounded-3xl p-8 md:p-10 border border-pastel-grey shadow-apple" data-id="element-458">
          <div className="text-center mb-8" data-id="element-459">
            <div className="w-16 h-16 mx-auto bg-pastel-pink-light rounded-2xl flex items-center justify-center mb-6" data-id="element-460">
              <ShieldAlert className="w-8 h-8 text-pink-600" data-id="element-461" />
            </div>
            <h1 className="text-3xl font-bold text-dark mb-3" data-id="element-462">
              Pelaporan Anonim
            </h1>
            <p className="text-gray-600 text-sm max-w-md mx-auto" data-id="element-463">
              Laporkan kejadian bullying, pelanggaran, atau masalah lainnya
              secara aman. Identitasmu 100% dirahasiakan.
            </p>
          </div>

          <div className="bg-pastel-blue-light/50 p-4 rounded-xl mb-8" data-id="element-464">
            <p className="text-xs text-blue-800 text-center font-medium" data-id="element-465">
              Sistem tidak merekam nama, email, atau data pribadimu saat
              mengirim laporan ini.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-466">
            <Input label="Detail Kejadian / Aduan" as="textarea" required value={content} onChange={e => setContent(e.target.value)} placeholder="Ceritakan secara detail..." className="min-h-[200px]" data-id="element-467" />

            <div data-id="element-468">
              <label className="block text-sm font-medium text-dark mb-2" data-id="element-469">
                Bukti Foto (Opsional)
              </label>

              {!file ? <div className="border-2 border-dashed border-pastel-grey rounded-xl p-8 text-center cursor-pointer" onClick={() => fileInputRef.current?.click()} data-id="element-470">
                  <Upload className="mx-auto h-8 w-8 text-gray-400 mb-3" data-id="element-471" />
                  <p className="text-sm text-gray-600 font-medium" data-id="element-472">
                    Klik untuk mengunggah foto
                  </p>
                </div> : <div className="flex items-center justify-between p-4 border rounded-xl" data-id="element-473">
                  <p data-id="element-474">{file.name}</p>
                  <button onClick={removeFile} data-id="element-475">
                    <X size={20} data-id="element-476" />
                  </button>
                </div>}

              <input type="file" ref={fileInputRef} onChange={handleFileChange} accept="image/*" className="hidden" data-id="element-477" />
            </div>

            <Button type="submit" fullWidth size="lg" isLoading={isSubmitting} disabled={!content.trim()} data-id="element-478">
              Kirim Laporan Anonim
            </Button>
          </form>
        </motion.div>
      </div>
    </div>;
}